import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useEffectWithDeepCompare } from '@gasbuddy/react-hooks';
import DropdownOption from './DropdownOption';
import DropdownSearchBox from './DropdownSearchBox';
import { KEYS } from '../../constants';
import ValuePropType from '../../prop-types/Value';
import OptionPropType from '../../prop-types/DropdownOption';
import sizePropTypes from '../../prop-types/Size';
import { noop } from '../../utils';
import styles from './dropdown.css';
import { Chevron } from '../../icons';
var cx = classnames.bind(styles);
var DROPDOWN_OPTION_TOTAL_HEIGHT = 42.5;
export default function Dropdown(_ref) {
  var animated = _ref.animated,
      bordered = _ref.bordered,
      className = _ref.className,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      inline = _ref.inline,
      name = _ref.name,
      native = _ref.native,
      noOptionsMessage = _ref.noOptionsMessage,
      onChange = _ref.onChange,
      onSearch = _ref.onSearch,
      optionBoxTitle = _ref.optionBoxTitle,
      options = _ref.options,
      placeholder = _ref.placeholder,
      searchable = _ref.searchable,
      searchPlaceholder = _ref.searchPlaceholder,
      size = _ref.size,
      tabIndex = _ref.tabIndex,
      upward = _ref.upward,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["animated", "bordered", "className", "defaultValue", "disabled", "inline", "name", "native", "noOptionsMessage", "onChange", "onSearch", "optionBoxTitle", "options", "placeholder", "searchable", "searchPlaceholder", "size", "tabIndex", "upward", "value"]);

  var isNativeWithoutPlaceholder = native && !placeholder && !value && options.length;

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      highlightedOptionIndex = _useState2[0],
      setHighlightedOptionIndex = _useState2[1];

  var _useState3 = useState(isNativeWithoutPlaceholder ? options[0].value : value || defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedValue = _useState4[0],
      setSelectedValue = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showOptions = _useState6[0],
      setShowOptions = _useState6[1];

  var _useState7 = useState(options),
      _useState8 = _slicedToArray(_useState7, 2),
      visibleOptions = _useState8[0],
      setVisibleOptions = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedValueScrollTopValue = _useState10[0],
      setSelectedValueScrollTopValue = _useState10[1];

  var containerElement = useRef(null);
  var scrollContainerElement = useRef(null);
  var selectElement = useRef(null);
  var handleClickOutside = useCallback(function (event) {
    var _containerElement$cur;

    if (!((_containerElement$cur = containerElement.current) === null || _containerElement$cur === void 0 ? void 0 : _containerElement$cur.contains(event.target)) && !!showOptions) {
      setShowOptions(false);
    }
  }, [showOptions]);
  useEffect(function () {
    document.addEventListener('click', handleClickOutside);
    return function () {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]); // If the options props change, update the state and ensure we scroll back to the top of the list

  useEffectWithDeepCompare(function () {
    setVisibleOptions(options);

    if (scrollContainerElement.current) {
      scrollContainerElement.current.scrollTop = 0;
      setSelectedValueScrollTopValue(0);
    }
  }, [options]);
  useEffect(function () {
    setSelectedValue(value !== undefined ? value : defaultValue);
  }, [defaultValue, value]);
  useEffect(function () {
    if (selectElement.current) {
      var event = new Event('change', {
        bubbles: true
      });
      selectElement.current.dispatchEvent(event);
    }
  }, [selectedValue]);

  function handleToggleClick() {
    setShowOptions(!showOptions);
  }

  var selectOption = function selectOption(newValue) {
    return function () {
      setShowOptions(false);
      setSelectedValue(newValue);
    };
  };

  function handleNativeOptionChange(event) {
    onChange(event); // if this didn't come from a native option change, then we don't need to update our state again

    if (native) {
      setShowOptions(false);
      setSelectedValue(event.target.value);
    }
  }

  var handleKeyDown = useCallback(function (e) {
    var keyCode = e.which || e.keyCode;
    var newOptionIndex = highlightedOptionIndex;

    if (showOptions) {
      if (keyCode === KEYS.UP_ARROW) {
        e.preventDefault();
        newOptionIndex = Math.max(highlightedOptionIndex - 1, 0);

        if (scrollContainerElement.current) {
          scrollContainerElement.current.scrollTop = DROPDOWN_OPTION_TOTAL_HEIGHT * Math.max(newOptionIndex - 2, 0);
        }

        setHighlightedOptionIndex(newOptionIndex);
      } else if (keyCode === KEYS.DOWN_ARROW) {
        e.preventDefault();
        newOptionIndex = Math.min(highlightedOptionIndex + 1, visibleOptions.length - 1);

        if (scrollContainerElement.current) {
          scrollContainerElement.current.scrollTop = DROPDOWN_OPTION_TOTAL_HEIGHT * Math.min(newOptionIndex - 2, visibleOptions.length - 1);
        }

        setHighlightedOptionIndex(newOptionIndex);
      } else if (keyCode === KEYS.ESCAPE) {
        e.preventDefault();
        setShowOptions(false); // ensure our highlighted index either returns to the top, or to where the selectedValue option is in the dropdown

        var selectedIndex = visibleOptions.findIndex(function (option) {
          return option.value === selectedValue;
        });
        setHighlightedOptionIndex(selectedIndex || -1); // ensure the options dropdown is scrolled appropriately to where our selected value is

        if (scrollContainerElement.current) {
          scrollContainerElement.current.scrollTop = selectedValueScrollTopValue;
        }
      } else if (keyCode === KEYS.ENTER) {
        e.preventDefault();
        setShowOptions(false); // set in state our new selected value, as well as where the options dropdown was scrolled to (in case a user opens it again)

        setSelectedValue(visibleOptions[newOptionIndex].value);

        if (scrollContainerElement.current) {
          setSelectedValueScrollTopValue(scrollContainerElement.current.scrollTop);
        }
      }
    }
  }, [highlightedOptionIndex, selectedValue, selectedValueScrollTopValue, showOptions, visibleOptions]);
  var handleSearch = useCallback(function (e) {
    var searchValue = e.target.value;

    if (onSearch) {
      onSearch(searchValue);
      return;
    }

    var newVisibleOptions = searchValue ? options.filter(function (option) {
      return option.label.toUpperCase().includes(searchValue.toUpperCase());
    }) : options;
    setVisibleOptions(newVisibleOptions);
  }, [onSearch, options]);
  var arrowDirection = upward ? !showOptions : showOptions;
  var selectedOption = visibleOptions.find(function (option) {
    var compareValue = selectedValue !== undefined ? selectedValue : defaultValue;
    return option.value === compareValue;
  });
  var toggleText;

  if (selectedOption && selectedOption.label) {
    toggleText = selectedOption.label;
  } else {
    toggleText = placeholder;
  }

  return React.createElement("div", _extends({
    "aria-expanded": showOptions,
    className: cx('container', size, {
      open: showOptions,
      inline: inline,
      native: native,
      upward: upward,
      animated: animated
    }, className),
    ref: containerElement
  }, rest), React.createElement("button", {
    className: cx('toggle', {
      bordered: bordered,
      opened: showOptions
    }),
    disabled: disabled,
    onClick: handleToggleClick,
    type: "button"
  }, toggleText || "\xA0", arrowDirection ? React.createElement(Chevron, {
    className: cx('icon'),
    direction: "up",
    height: "0.8em",
    width: "0.8em"
  }) : React.createElement(Chevron, {
    className: cx('icon'),
    height: "0.8em",
    width: "0.8em"
  })), React.createElement("div", {
    className: cx('optionBox')
  }, searchable && React.createElement(DropdownSearchBox, {
    bordered: bordered,
    onSearch: handleSearch,
    placeholder: searchPlaceholder
  }), optionBoxTitle && React.createElement("span", {
    className: cx('option', 'title')
  }, optionBoxTitle), React.createElement("ul", {
    "aria-activedescendant": highlightedOptionIndex >= 0 ? "option".concat(highlightedOptionIndex) : '',
    className: cx('options'),
    onKeyDown: handleKeyDown,
    ref: scrollContainerElement,
    role: "listbox",
    tabIndex: "0"
  }, visibleOptions && visibleOptions.map(function (option, idx) {
    return React.createElement(DropdownOption, {
      id: "option".concat(idx),
      isLast: idx === visibleOptions.length - 1,
      isSelected: selectedOption && selectedOption.value === option.value || highlightedOptionIndex === idx,
      key: option.value,
      onClick: selectOption(option.value),
      option: option
    });
  }), !visibleOptions.length && React.createElement(DropdownOption, {
    disabled: true,
    noOptionsMessage: noOptionsMessage
  }))), React.createElement("select", {
    name: name,
    onChange: handleNativeOptionChange,
    ref: selectElement,
    tabIndex: native ? tabIndex : -1,
    value: selectedValue
  }, placeholder && React.createElement("option", {
    value: ""
  }, placeholder), visibleOptions.map(function (option) {
    return React.createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })));
}
Dropdown.propTypes = {
  /** Boolean to indicate if the options should fade in/out  */
  animated: PropTypes.bool,

  /** Boolean to set box-shadow on dropdown and dropdown search elements */
  bordered: PropTypes.bool,

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Initially selected value */
  defaultValue: ValuePropType,

  /** Boolean to disable the element */
  disabled: PropTypes.bool,

  /** Boolean allowing input to be displayed inline */
  inline: PropTypes.bool,

  /** Field name */
  name: PropTypes.string,

  /** Boolean to show a native select element */
  native: PropTypes.bool,

  /** Message that appears in dropdown when no options are available to select */
  noOptionsMessage: PropTypes.string,

  /** Change handler */
  onChange: PropTypes.func,

  /** Handler for when user types in the searchbox of the dropdown */
  onSearch: PropTypes.func,

  /** The title appearing above the options in the dropdown container */
  optionBoxTitle: PropTypes.string,

  /** An array of OptionPropTypes. The render prop is given its label automatically */
  options: PropTypes.arrayOf(OptionPropType),

  /** Placeholder text */
  placeholder: PropTypes.string,

  /** Boolean to indicate if the dropdown has a search textbox */
  searchable: PropTypes.bool,

  /** Placeholder text for the search box */
  searchPlaceholder: PropTypes.string,

  /** String that represents size of input */
  size: sizePropTypes,

  /** Tab index of dropdown */
  tabIndex: PropTypes.number,

  /** Boolean to open the options upward */
  upward: PropTypes.bool,

  /** Currently selected value */
  value: ValuePropType
};
Dropdown.defaultProps = {
  animated: true,
  bordered: true,
  className: undefined,
  defaultValue: undefined,
  disabled: false,
  inline: false,
  name: undefined,
  native: false,
  noOptionsMessage: 'No options available',
  onChange: noop,
  onSearch: undefined,
  optionBoxTitle: undefined,
  options: [],
  placeholder: undefined,
  searchable: false,
  searchPlaceholder: 'Search...',
  size: 'md',
  tabIndex: undefined,
  upward: false,
  value: undefined
};